import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { EnhancedBanner } from "@/libraries/design/components/enhanced-banner/src/enhanced-banner";
import { useLocalizedHref } from "@/libraries/web-framework/index.ts";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const HomePageBannerAlert = () => {
    const intl = useIntl();

    const bannerHref = useLocalizedHref("/team");

    if (checkFeatureFlagGate(featureFlags.gwp9226Team26Banner)) {
        return (
            <UFOSegment name="homepage-banner-for-team-26">
                <EnhancedBanner
                    uniqueIdentifier="homepage-banner-for-team-26"
                    heading={intl.formatMessage({
                        id: "HomePage.banner-alert.team-26.heading",
                        defaultMessage: "May 5 - 7  •  Anaheim, California"
                    })}
                    subheading={intl.formatMessage({
                        id: "HomePage.banner-alert.team-26.subheading",
                        defaultMessage:
                            "Get the most savings on your in-person pass & experience the AI tools fueling better teamwork."
                    })}
                    subheadingMobile={intl.formatMessage({
                        id: "HomePage.banner-alert.team-26.subheading",
                        defaultMessage: "Save big on your in-person pass"
                    })}
                    ctaLinkHref={bannerHref}
                    ctaLinkText="Register now"
                    productKey="home"
                    logoSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/p8na60e0488c54y2pj2l0oy184f23bg3.png"
                    logoAlt="Team 26"
                    backgroundImageDesktop="https://dam-cdn.atl.orangelogic.com/AssetLink/65yptj77sdkwv3tr84k58eae2i3d2d17.webp"
                    backgroundImageTablet="https://dam-cdn.atl.orangelogic.com/AssetLink/5bio0v54ttg7k5e1s1r380ode2h46xml.webp"
                    backgroundImageMobile="https://dam-cdn.atl.orangelogic.com/AssetLink/27pf0qlj6ilylq2hor6k233caw6706j3.webp"
                    backgroundColor="lightBlue"
                />
            </UFOSegment>
        );
    }
};
